import 'babel-polyfill';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/incredible/incredible.css';
import './styles/aos.css';
import './styles/slick.min.css';
import './styles/slick-theme.min.css';
import App from './App';
import unregister from './registerServiceWorker';
import { HashRouter, Route } from 'react-router-dom';
import { createStore, compose, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import localforage from 'localforage';
import { persistCombineReducers, persistStore, REHYDRATE, PERSIST } from 'redux-persist';
import { PersistGate } from 'redux-persist/es/integration/react';
import ReactLoading from 'react-loading';
import { StorageConfig } from './configs';
import UserReducer from './reducers/userReducer';
import ProductReducer from './reducers/productReducer';
import UIReducer from './reducers/uiReducer';
import axios from 'axios';
import * as UIActions from './actions/uiAction';
import 'date-input-polyfill-2';

unregister();

const unregisterSW = async () => {
    try {
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (let i = 0; i < registrations.length; i += 0) {
                const registration = registrations[i];
                const unregisterResult = await registration.unregister();
                console.log('service worker unregistered: ', unregisterResult);
            }
        }
    } catch (err) {
        console.log(err, { depth: null, colors: true });
    }
};

unregisterSW();

const baseUrl = process.env.PUBLIC_URL;
const composeEnhancers = process.env.NODE_ENV === 'development' ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;

/** store initialization **/
localforage.config(StorageConfig);
let storeRehydrating = true;
const storageMiddleware = (store) => (next) => (action) => {
    if (action.type === REHYDRATE || action.type === PERSIST || storeRehydrating) {
        return next(action);
    }
    const stampedAction = {
        action,
        timeStamp: Date.now()
    };

    localStorage.setItem('LAST-ACTION', JSON.stringify(stampedAction));

    next(action);
};

const middleware = [thunk, storageMiddleware];

const reducer = persistCombineReducers({
    key: 'root',
    storage: localforage,
    debug: process.env.NODE_ENV === 'development'
}, {
    UserStore: UserReducer,
    ProductStore: ProductReducer,
    UiStore: UIReducer,
});

export const store = createStore(
    reducer,
    composeEnhancers(
        applyMiddleware(...middleware)
    )
);

/** axios interceptors **/
axios.interceptors.request.use((config) => {
    const { UserStore, locales } = store.getState();
    let locale = locales.locale || 'en';

    let headers = {
        "Accept-Language": locale,
    };

    if (UserStore && UserStore.authToken) {
        headers = {
            ...headers,
            "x-public-token": UserStore.authToken
        }
    }

    config.headers = {
        ...headers,
        ...config.headers
    };
    return config
}, (error) => {
    let err = error.response && error.response.data ? error.response.data : error;
    store.dispatch(UIActions.addError(err));
    store.dispatch(UIActions.appReady());
    return Promise.reject(err)
});

axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    let err = error.response && error.response.data ? error.response.data : error;

    console.log(error.response.data.code, 'error')

    if (error.response.data.code === 'VERIFICATION_FAILED') {
        store.dispatch(UIActions.appReady());
    } else if (error.response.data.code === 'INVALID_PROMO_CODE') {
        store.dispatch(UIActions.appReady());
    } else if (error.response.data.code === 'MULTIPLE_USER_ACCOUNT') {
        store.dispatch(UIActions.appReady());
    } else {
        store.dispatch(UIActions.appReady());
        store.dispatch(UIActions.addError(err));
    }
    return Promise.reject(err)
});

const persistor = persistStore(store, null, () => {
    // const { SESSION_TIMEOUT } = AppConfig;
    // const lastAction = JSON.parse(localStorage.getItem('LAST-ACTION')) || {};
    // if (((Date.now() - lastAction.timeStamp) > (SESSION_TIMEOUT - (60 * 1000))) ||
    //     (lastAction.action && lastAction.action.type === UserActions.USER_LOGOUT)) {
    //     store.dispatch(UserActions.logout())
    // }

    // force locale to reload messages
    // const { locales } = store.getState();
    // const langArray = ['en', 'ko', 'zh', 'id', 'th'];
    // let lang = locales.locale || navigator.language || navigator.browserLanguage;
    // lang = lang.substring(0, 2);
    // if (langArray.indexOf(lang) === -1) {
    //     lang = 'en';
    // }
    // changeLocale(lang);
    storeRehydrating = false;
});

ReactDOM.render(
    <Provider store={store}>
        <PersistGate
            loading={<ReactLoading />}
            persistor={persistor}>
            <HashRouter basename={baseUrl}>
                <Route path="/" component={App} />
            </HashRouter>
        </PersistGate>
    </Provider>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js